export interface MenuItem {
  labelKey: string
  path: string
  iconPath: string
  exact?: boolean
  badge?: number
  children?: MenuItem[]
  category?: string
  keywords?: string[]
  priority?: number
}

export interface MenuGroup {
  titleKey: string
  items: MenuItem[]
  collapsible?: boolean
  priority?: number
}

export const menuGroups: MenuGroup[] = [
  {
    titleKey: 'sidebar.section.overview',
    priority: 1,
    items: [
      {
        labelKey: 'sidebar.menu.dashboard',
        path: '/',
        exact: true,
        priority: 1,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>',
        keywords: ['home', 'overview', 'main', 'dasbor', 'utama'],
      },
      {
        labelKey: 'sidebar.menu.executiveSummary',
        path: '/executive-summary',
        priority: 2,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>',
        keywords: ['presentation', 'summary', 'executive', 'laporan', 'presentasi'],
      },
      {
        labelKey: 'sidebar.menu.pmMonitoring',
        path: '/pm-monitoring',
        priority: 3,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>',
        keywords: ['pm', 'monitoring', 'preventive', 'pemantauan'],
      },
      {
        labelKey: 'sidebar.menu.fleetDatabase',
        path: '/fleet/database',
        priority: 4,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"></path>',
        keywords: ['database', 'fleet', 'armada'],
      },
    ],
  },
  {
    titleKey: 'sidebar.section.maintenance',
    collapsible: true,
    priority: 2,
    items: [
      {
        labelKey: 'sidebar.menu.maintenanceRequests',
        path: '/maintenance-requests',
        priority: 1,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>',
        keywords: ['maintenance', 'request', 'pemeliharaan', 'permintaan'],
      },
      {
        labelKey: 'sidebar.menu.workOrders',
        path: '/work-orders',
        priority: 2,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>',
        keywords: ['work', 'order', 'wo', 'pekerjaan'],
      },
      {
        labelKey: 'sidebar.menu.breakdowns',
        path: '/breakdowns',
        priority: 3,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>',
        keywords: ['breakdown', 'emergency', 'kerusakan', 'darurat'],
      },
      {
        labelKey: 'sidebar.menu.maintenanceBacklog',
        path: '/maintenance-backlog',
        priority: 4,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"></path>',
        keywords: ['backlog', 'pending', 'tertunda'],
      },
    ],
  },
  {
    titleKey: 'sidebar.section.fleet',
    collapsible: true,
    priority: 3,
    items: [
      {
        labelKey: 'sidebar.menu.units',
        path: '/units',
        priority: 1,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>',
        keywords: ['unit', 'asset', 'equipment', 'alat'],
      },
      {
        labelKey: 'sidebar.menu.serviceSchedule',
        path: '/fleet/schedule',
        priority: 2,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>',
        keywords: ['schedule', 'service', 'jadwal'],
      },
      {
        labelKey: 'sidebar.menu.fuelManagement',
        path: '/fuel-management',
        priority: 3,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"></path>',
        keywords: ['fuel', 'bahan bakar', 'bbm'],
      },
      {
        labelKey: 'sidebar.menu.pmStandardParts',
        path: '/pm-standard-parts',
        priority: 4,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"></path>',
        keywords: ['parts', 'standard', 'sparepart', 'komponen'],
      },
    ],
  },
  {
    titleKey: 'sidebar.section.inventory',
    collapsible: true,
    priority: 4,
    items: [
      {
        labelKey: 'sidebar.menu.inventory',
        path: '/inventory',
        priority: 1,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>',
        keywords: ['inventory', 'stock', 'persediaan'],
      },
      {
        labelKey: 'sidebar.menu.purchaseRequests',
        path: '/purchase-requests',
        priority: 2,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"></path>',
        keywords: ['purchase', 'request', 'pembelian', 'permintaan'],
      },
    ],
  },
  {
    titleKey: 'sidebar.section.dataAudit',
    collapsible: true,
    priority: 5,
    items: [
      {
        labelKey: 'sidebar.menu.auditTrail',
        path: '/audit-trail',
        priority: 1,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>',
        keywords: ['audit', 'trail', 'history', 'logs', 'aktifitas'],
      },
      {
        labelKey: 'sidebar.menu.unitReports',
        path: '/unit-reports',
        priority: 2,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>',
        keywords: ['reports', 'pdf', 'export', 'laporan', 'cetak'],
      },
    ],
  },
  {
    titleKey: 'sidebar.section.settings',
    collapsible: true,
    priority: 6,
    items: [
      {
        labelKey: 'sidebar.menu.sites',
        path: '/sites',
        priority: 1,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>',
        keywords: ['site', 'location', 'lokasi', 'tempat'],
      },
      {
        labelKey: 'sidebar.menu.userPermissions',
        path: '/user-permissions',
        priority: 2,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"></path>',
        keywords: ['user', 'permissions', 'pengguna', 'izin'],
      },
      {
        labelKey: 'sidebar.menu.helpAndFlow',
        path: '/help-and-flow',
        priority: 3,
        iconPath:
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>',
        keywords: ['help', 'support', 'bantuan', 'flow'],
      },
    ],
  },
]
